import { render, staticRenderFns } from "./PrivacyNoticeScienceExileOnlineFormDeclaration.vue?vue&type=template&id=2830cfef&scoped=true&"
import script from "./PrivacyNoticeScienceExileOnlineFormDeclaration.vue?vue&type=script&lang=js&"
export * from "./PrivacyNoticeScienceExileOnlineFormDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830cfef",
  null
  
)

export default component.exports